// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap_13m_u","gridGap":"index_gridGap_3nywF","titleExtend":"index_titleExtend_dEPO4"};